import { authTokenManager } from "../../Globals";
export class VideoAuth {
    userId;
    constructor(userId) {
        this.userId = userId;
    }
    async waitForToken() {
        return process.env.MOCK_AUTH_TOKEN_MANAGER
            ? Promise.resolve()
            : authTokenManager.waitForToken();
    }
    latestToken() {
        return process.env.MOCK_AUTH_TOKEN_MANAGER
            ? JSON.stringify({ sub: this.userId })
            : authTokenManager.latestToken();
    }
}
//# sourceMappingURL=VideoAuth.js.map